"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertUTCDateToLocalDate = void 0;
const convertUTCDateToLocalDate = (date) => new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()));
exports.convertUTCDateToLocalDate = convertUTCDateToLocalDate;
//# sourceMappingURL=date.js.map